import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
  TextField, Box, Typography, Alert, CircularProgress
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import FinancialPreview from './FinancialPreview';
import billingApi from '../../services/billingApi';

export default function ApprovalDialog({ open, onClose, approval, onDecided }) {
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleDecision(decision) {
    setLoading(true);
    setError('');
    try {
      const endpoint = decision === 'approved'
        ? `/api/admin/workflows/instances/${approval.instance_id}/approve`
        : `/api/admin/workflows/instances/${approval.instance_id}/reject`;

      await billingApi.post(endpoint, { reason });
      if (onDecided) onDecided(decision);
      onClose();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  if (!approval) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Approval Required</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2" color="text.secondary">Workflow</Typography>
          <Typography>{approval.definition_name || approval.instance_id}</Typography>
        </Box>

        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2" color="text.secondary">Reason for approval</Typography>
          <Typography>{approval.reason || 'No reason provided'}</Typography>
        </Box>

        {approval.financial_impact && (
          <FinancialPreview preview={approval.financial_impact} />
        )}

        <TextField
          label="Decision reason"
          value={reason}
          onChange={e => setReason(e.target.value)}
          fullWidth
          multiline
          rows={2}
          size="small"
          sx={{ mt: 2 }}
          placeholder="Optional: explain your decision..."
        />
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Close</Button>
        <Button
          onClick={() => handleDecision('rejected')}
          disabled={loading}
          color="error"
          variant="outlined"
          startIcon={<CancelIcon />}
        >
          Reject
        </Button>
        <Button
          onClick={() => handleDecision('approved')}
          disabled={loading}
          color="success"
          variant="contained"
          startIcon={loading ? <CircularProgress size={16} /> : <CheckCircleIcon />}
        >
          Approve
        </Button>
      </DialogActions>
    </Dialog>
  );
}
